/** A licence or demo date in the UI language; `ua` is not a BCP 47 tag, `uk-UA` is. */
export function formatLicenceDate(value: string | null, language: string | undefined): string {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  const locale = language === 'ua' ? 'uk-UA' : language
  return new Intl.DateTimeFormat(locale, { dateStyle: 'long' }).format(date)
}
